import { createReducer, on } from '@ngrx/store';
import { StatusGraphState } from './status-graph.state';

import * as actions from './status-graph.actions';

const initialState: StatusGraphState = {
  loading: false,
  statusGraph: [],
};

export const statusGraphReducer = createReducer(
  initialState,
  on(actions.fetchStatusGraph, (state) => ({
    ...state,
    loading: true,
  })),
  on(actions.fetchStatusGraphFail, (state) => ({
    ...state,
    loading: false,
  })),
  on(actions.fetchStatusGraphSuccess, (state, { statusGraph }) => ({
    ...state,
    statusGraph,
    loading: false,
  })),
);
